<template>
  <div class="EventTotal">
    <div class="chart" ref="chart" />
  </div>
</template>

<script>
import echarts from "echarts";
import api from '../api'
export default {
  name: "EventTotal",
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.queryInfo()
  },
  methods: {
    async queryInfo() {
      const { success, returnObj } = await this.$fetch(api.emergency.statEmergencyByStatus)
      if (success) {
        const xData = Object.keys(returnObj.dataMap)
        const yData = []
        Object.keys(returnObj.dataMap).forEach(key => {
          yData.push(returnObj.dataMap[key])
        })
        this.initCharts(xData, yData)
      }
    },
    initCharts(xData, yData) {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const option = {
        grid: {
          bottom: 10,
          top: 10,
          containLabel: true,
          left: 25,
          right: 10,
        },
        tooltip: {
          trigger: 'item'
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisTick: {
              show: false,
            },
            axisLabel: {
              // color: "rgba(255,255,255,0.7)",
              color: "#ffffff",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#1B7EF2",
              }
            }
          }
        ],
        yAxis: [
          {
            show: true,
            type: "value",
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#2D3C5C",
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [24, 12],
            symbolOffset: [0, -4], // 上部椭圆
            symbolPosition: "end",
            z: 12,
            // "barWidth": "0",
            itemStyle: {
              color: '#FFD982'
            },
            data: yData
          },
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [24, 12],
            symbolOffset: [0, 0], // 底部椭圆
            z: 12,
            // "barWidth": "0",
            itemStyle: {
              color: 'rgba(255, 217, 130, .4)'
            },
            data: yData
          },
          {
            type: "bar",
            barWidth: "24px",
            itemStyle: {
              color: 'rgba(255,217,130,0.4)'
            },
            data: yData
          },
        ],
      };

      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
.EventTotal {
  height: 100%;
  width: 100%;

  .chart {
    height: 100%;
    width: 100%;
  }
}
</style>
